import {getRequest, postRequest} from '../lib/request'

export function findByCriteria(criteria) {
    return getRequest(`/course-detail/findByCriteria`, criteria)
}

